<template>
  <div
    v-bind="$attrs"
    v-on="$listeners"
    :style="style.container"
  >
    <ValidationObserver ref="observer">
      <div :style="style.nameRow">
        <div :style="style.firstNameRow">
          <TextFormLabelPrimary :style="style.label">
            First name
          </TextFormLabelPrimary>
          <InputSecondary
            v-model="form.data.firstName"
            formName="first name"
            placeholder="Your first name"
            :rules="rules.name"
            @change-input="updateFormData"
          />
        </div>
        <div :style="style.lastNameRow">
          <TextFormLabelPrimary :style="style.label">
            Last name
          </TextFormLabelPrimary>
          <InputSecondary
            v-model="form.data.lastName"
            formName="last name"
            placeholder="Your last name"
            :rules="rules.name"
            @change-input="updateFormData"
          />
        </div>
      </div>
      <div :style="style.row">
        <TextFormLabelPrimary :style="style.label">
          Email
        </TextFormLabelPrimary>
        <InputSecondary
          :disabled="true"
          v-model="form.data.email"
          formName="email"
          placeholder="Your last name"
          :rules="rules.email"
          @change-input="updateFormData"
        />
      </div>
      <div
        v-if="requirePassword"
        :style="style.row"
      >
        <TextFormLabelPrimary :style="style.label">
          Password
        </TextFormLabelPrimary>
        <InputSecondary
          v-model="form.data.password"
          formName="password"
          inputType="password"
          placeholder="Enter your password"
          :rules="rules.password"
          @change-input="updateFormData"
        />
      </div>
      <div
        v-if="requirePassword"
        :style="style.row"
      >
        <TextFormLabelPrimary :style="style.label">
          Confirm password
        </TextFormLabelPrimary>
        <InputSecondary
          v-model="form.data.passwordConfirmation"
          formName="password confirmation"
          inputType="password"
          placeholder="Re-enter your password"
          :rules="rules.passwordConfirmation"
          @change-input="updateFormData"
        />
      </div>
    </ValidationObserver>
  </div>
</template>

<script>
  import InputSecondary from '@modules/v2/input/input-secondary'
  import TextFormLabelPrimary from '@modules/v2/text/text-form-label-primary'
  import { confirmed, email, min, required, strong_password }
    from '@js/validators/rules'
  import { getValidationObserverErrors } from '@js/validators/validator-utils'
  import { Layout } from '@js/styles'
  import { ValidationObserver } from 'vee-validate'

  export default {
    name: 'FormSignupPrimary',
    inheritAttrs: false,
    components: {
      InputSecondary,
      TextFormLabelPrimary,
      ValidationObserver,
    },
    props: {
      form: {
        type: Object,
        required: false,
        default: () => {},
      },
      requirePassword: {
        type: Boolean,
        required: false,
        default: false,
      },
    },
    data: function () {
      return {
        rules: {
          name: 'required|min:1',
          email: 'required|email',
          password: 'required|min:8|strong_password',
          passwordConfirmation: 'required|confirmed:password',
        },
        style: {
          container: {
            height: 'fit-content',
            width: '100%',
          },
          firstNameRow: {
            flex: 1,
            margin: `${Layout.space.lg} 0 0 0`,
            padding: `0 ${Layout.space.sm}`,
          },
          label: {
            margin: `0 0 ${Layout.space.sm} 0`,
          },
          lastNameRow: {
            flex: 1,
            margin: `${Layout.space.lg} 0 0 0`,
            padding: `0 ${Layout.space.sm}`,
          },
          nameRow: {
            display: 'flex',
            flexWrap: 'wrap',
            width: '100%',
          },
          row: {
            display: 'flex',
            flexDirection: 'column',
            margin: `${Layout.space.lg} 0 0 0`,
            padding: `0 ${Layout.space.sm}`,
            width: '100%',
          },
        },
      };
    },
    mounted: function () {
      this.$watch(
        () => this.$refs.observer.errors,
        (newErrorObj, _) => {
          this.form.errors = getValidationObserverErrors(newErrorObj);
          this.updateFormData();
        }
      );
    },
    methods: {
      updateFormData: function () {
        this.$emit('update:form', this.form);
      },
    },
  };
</script>
